import React, { useEffect } from 'react';
import styled from 'styled-components';

const ButtonWrapper = styled.button<{
  backgroundColor: string;
  color: string;
  disabled: boolean;
}>`
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background-color: ${(props) => props.backgroundColor};
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};

  p {
    font-weight: 600;
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    color: ${(props) => props.color};
    @media only screen and (max-width: 440px) {
      font-size: 12px;
    }
  }
`;

const Button = ({
  backgroundColor,
  color,
  text,
  isLoading,
  isDisabled,
  onClick,
  dataTour = null,
}): JSX.Element => {
  const [isLoadingState, setIsLoadingState] = React.useState(isLoading);
  useEffect(() => {
    setIsLoadingState(isLoading);
  }, [isLoading]);
  return (
    <ButtonWrapper
      onClick={() => (isLoadingState ? null : onClick())}
      backgroundColor={backgroundColor}
      disabled={isDisabled}
      color={color}
      data-tour={dataTour}
    >
      {!isLoadingState ? <p>{text}</p> : <div className="tidal-loader"></div>}
    </ButtonWrapper>
  );
};

export default Button;
